<template>
  <div :class="['jobody',{'full_screen':layout=='rc'}]" id="jobody">
    <abstract></abstract>
    <keyword></keyword>
    <ocis v-if="ARTICLE.ocis"></ocis>
    <highlight v-if="ARTICLE.highlights && ARTICLE.highlights.length>0"></highlight>
    <div :class="{'justify-align' : ARTICLE.defaultlang == 'zh', 'left-align' : ARTICLE.defaultlang == 'en'}">
    <component :is="'jo' + item.name" v-for="item in body" v-bind:key="item.index" v-bind:data="item.data"></component>
    <response></response>
    <conandack></conandack>
    <supplementary v-if="ARTICLE.supplementary && ARTICLE.supplementary.length>0"></supplementary>
    <conflict></conflict>
    <ethics></ethics>
    <supportedby></supportedby>
    <glossary></glossary>
    <appendix v-if="ARTICLE.appendix && ARTICLE.appendix.length > 0"></appendix>
    <sub-article v-if="ARTICLE.subArticles"></sub-article>
    </div>
    <reference v-if="ARTICLE.reflist && ARTICLE.reflist.data.length > 0" :parent="'body'"></reference>
  </div>
</template>

<script>
  import jofig from './fig/fig.vue'
  import jodispformula from './formula/dispformula.vue'
  import jotable from './table/table.vue'
  import jofiggroup from './fig/figgroup.vue'
  import jodispquote from './dispquote/dispquote.vue'
  import abstract from './abstract/abstract.vue'
  import keyword from './keyword/keyword.vue'
  import ocis from './ocis/ocis.vue'
  import response from './response/response.vue'
  import glossary from './glossary/glossary.vue'
  import reference from './reference/reference.vue'
  import conandack from './conandack/conandack.vue'
  import conflict from './conflict/conflict.vue'
  import supportedby from './supportedby/supportedby.vue'
  import appendix from './appendix/appendix.vue'
  import supplementary from './supplementary/supplementary.vue'
  import highlight from './highlight/highlight.vue'
  import subArticle from '../../../commonComponents/subArticle.vue'
  import ethics from '../../../commonComponents/ethics.vue'

  export default {
    components: {
      jofig,
      jodispformula,
      jotable,
      jofiggroup,
      jodispquote,
      abstract,
      keyword,
      ocis,
      response,
      glossary,
      reference,
      conandack,
      conflict,
      supportedby,
      appendix,
      supplementary,
      highlight,
      subArticle,
      ethics
    },
    name: "jobody",
    data() {
      return {
        height: 0,
        body: []
      }
    },
    created() {
      this.body = this.ARTICLE.body
    },
    activated(){
      this.body = this.ARTICLE.body
    },
    deactivated(){
      this.body = []
    }
  }
</script>

<style lang="scss" scoped>
  @import "./../../../assets/css/mixins";
  .jobody {
    width: calc(75% - 30px);
    position: relative;
    text-align: left;
    /*float: right;*/
    margin:0 10px 0 auto;
    padding-right: 3%;
    padding-left: 1%;
    background-color: #fff;
    @include screen(0px,800px){
      width: calc(94% - 20px) !important;
      padding-left: 3%;
      margin:0 10px 0 10px;
    }
  }
  .full_screen{
    width: calc(98% - 30px);
    margin-top: 50px;
    padding-right: 3%;
    padding-left: 1.5%;
  }
</style>




// WEBPACK FOOTER //
// src/components/maincontent/body/body.vue